import { BasicService } from "./core/basic.service";

export class ManagerService extends BasicService {

  static getManagerInfo() {
    return this.http.post('/power/AdminInfo')
  }

  static getManager(id) {
    return this.http.post('/power/AdminInfo', { id });
  }

  static saveManager({ role_id, username, pwd, mobile, append_act, id }) {
    return this.http.post('/power/AdminSave', { role_id, username, pwd, mobile, append_act, id });
  }

  static deleteManager(id) {
    return this.http.post('/power/AdminDel', { id });
  }
}